module.exports = __webpack_public_path__ + "static/reactlg120-fa80844cbed16116aa0d2337927b85ca.png";